import Swiper, {Navigation, Thumbs, EffectFade, Autoplay} from 'swiper/core';

// configure Swiper to use modules
Swiper.use([Navigation, Thumbs, EffectFade, Autoplay]);

// init Swiper:

export const sliderPaginationConfiguration = {
  el: '.swiper-pagination',
  dynamicBullets: true,
  clickable: true,
};

export class TeaserSliderController {

  constructor() {
    if (document.querySelectorAll('.js-teaserSlider')?.length) {
      this.init();
    }
  }

  init() {
    new Swiper('.js-teaserSlider', {
      slidesPerView: 1,
      spaceBetween: 10,
      watchOverflow: true,
      breakpoints: {
        601: {
          slidesPerView: 2,
        },
        769: {
          slidesPerView: 4,
        },
        1025: {
          slidesPerView: 5,
        },
        1451: {
          slidesPerView: 6,
        },
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: sliderPaginationConfiguration,
    });
  }
}

export class ArticleSliderController {

  constructor() {
    if (document.querySelectorAll('.js-articleSlider')?.length) {
      this.init();
    }
  }

  init() {
    const hasAnchorNavigation = document.querySelector('.page--anchorNavigation');
    const isArticlePage = document.querySelector('.page--article');
    new Swiper('.js-articleSlider', {
      slidesPerView: 1,
      spaceBetween: 20,
      watchOverflow: true,
      breakpoints: {
        601: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        769: {
          slidesPerView: 2,
          spaceBetween: 35,
        },
        1025: {
          slidesPerView: hasAnchorNavigation || isArticlePage ? 2 : 3,
          spaceBetween: 35,
        },
        1451: {
          slidesPerView: 3,
          spaceBetween: 35,
        },
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: sliderPaginationConfiguration,
    });

    const articleSlider = document.querySelector('.js-articleSlider') as HTMLElement;
    let articles = articleSlider.querySelectorAll('.article');
    articles.forEach((article) => {
      article.classList.remove('hide');
    });
  }
}

export class TeaserBoxController {
  constructor() {
    if (document.querySelectorAll('.js-teaserBoxSlider')?.length) {
      this.init();
    }
  }

  init() {
    let swiper;
    const breakpoint = window.matchMedia('(min-width:769px)');

    const breakpointChecker = function () {
      if (breakpoint.matches) {
        if (swiper !== undefined) {
          swiper.destroy(true, true);
        }
        return;
      } else {
        return enableSwiper();
      }
    };

    const enableSwiper = function () {
      swiper = new Swiper('.js-teaserBoxSlider', {
        slidesPerView: 1,
        spaceBetween: 8,
        watchOverflow: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: sliderPaginationConfiguration,
      });
    };

    breakpoint.addEventListener('change', breakpointChecker);

    breakpointChecker();
  }
}

export class RecommendationModuleController {
  constructor() {
    if (document.querySelectorAll('.js-recommendationModuleSlider')?.length) {
      this.init();
    }
  }

  init() {
    let swiper: Swiper;
    const breakpoint = window.matchMedia('(min-width:769px)');

    const breakpointChecker = function () {
      if (breakpoint.matches) {
        if (swiper !== undefined) {
          swiper.destroy(true, true);
        }
        return;
      } else {
        return enableSwiper();
      }
    };

    const enableSwiper = function () {
      swiper = new Swiper('.js-recommendationModuleSlider', {
        slidesPerView: 1,
        spaceBetween: 25,
        watchOverflow: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      });
    };

    breakpoint.addEventListener('change', breakpointChecker);

    breakpointChecker();
  }
}

export class QuoteSliderController {

  constructor() {
    if (document.querySelectorAll('.js-quoteSlider')?.length) {
      this.init();
    }
  }

  init() {
    new Swiper('.js-quoteSlider', {
      slidesPerView: 1,
      spaceBetween: 0,
      watchOverflow: true,
      navigation: {
        nextEl: '.quoteSlider__elementTextButtonsNext',
        prevEl: '.quoteSlider__elementTextButtonsPrev',
      },
      pagination: sliderPaginationConfiguration,
    });
  }
}

export class AdvantageSliderController {
  swiper: Swiper | null = null;
  currentMobileMatch: MediaQueryList;
  mobileQuery: string = '(max-width: 460px)';

  constructor() {
    this.currentMobileMatch = window.matchMedia(this.mobileQuery);
    if (document.querySelectorAll('.js-advantageSlider')?.length) {
      if (!this.currentMobileMatch.matches) {
        this.initializeSwiper();
      }
    }
  }

  initializeSwiper(): void {
    if (this.swiper === null) {
      this.swiper = new Swiper('.js-advantageSlider', {
        slidesPerView: 1,
        watchOverflow: true,
        spaceBetween: 30,
        breakpoints: {
          461: {
            slidesPerView: 2,
          },
          769: {
            slidesPerView: 3,
          },
          1025: {
            slidesPerView: 5,
          },
          1451: {
            slidesPerView: 6,
          },
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      });
    }
  }
}

export class ProductGalleryController {

  constructor() {
    if (document.querySelectorAll('.js-product-gallery')?.length) {
      this.initGallery();
    }
  }

  initGallery() {
    const swiperThumbs: Swiper = new Swiper('.js-product-gallery-thumbs', {
      spaceBetween: 10,
      slidesPerView: 5,
      freeMode: true,
      watchOverflow: true,
      watchSlidesProgress: true,
    });

    new Swiper('.js-product-gallery', {
      effect: 'fade',
      speed: 300,
      slidesPerView: 1,
      loop: true,
      fadeEffect: {
        crossFade: true,
      },
      thumbs: {
        swiper: swiperThumbs,
      },
    });
  }
}

export class BigSliderController {

  constructor() {
    if (document.querySelectorAll('.js-bigSlider')?.length) {
      this.init();
    }
  }

  init() {
    const bigSliderThumbs: Swiper = new Swiper('.js-bigSliderThumbs', {
      spaceBetween: 40,
      slidesPerView: 3,
      allowTouchMove: false,
    });

    const bigSlider = new Swiper('.js-bigSlider', {
      slidesPerView: 1,
      spaceBetween: 0,
      watchOverflow: true,
      loop: true,
      effect: 'fade',
      height: 575,
      speed: 250,
      navigation: {
        prevEl: '.bigSlider__navigation--prev',
        nextEl: '.bigSlider__navigation--next',
      },
      pagination: sliderPaginationConfiguration,
      thumbs: {
        swiper: bigSliderThumbs,
      },
      autoplay: {
        delay: 6000,
        disableOnInteraction: false,
      },
      on: {
        init: () => {
          const activeProgressBar = document.querySelector('.swiper-slide-thumb-active .js-sliderProgress');
          activeProgressBar?.classList.remove('sliderProgress--animate');
          activeProgressBar?.classList.remove('sliderProgress--active');
          activeProgressBar?.classList.add('sliderProgress--animate');
          activeProgressBar?.classList.add('sliderProgress--active');
        },
      },
    });

    bigSlider.on('slideChangeTransitionStart', () => {
      const otherProgressBars = document.querySelectorAll('.js-sliderProgress');
      otherProgressBars.forEach((element, index) => {
        element.classList.remove('sliderProgress--animate');
      });
      const activeProgressBar = document.querySelector('.swiper-slide-thumb-active .js-sliderProgress');
      activeProgressBar?.classList.remove('sliderProgress--animate');
      activeProgressBar?.classList.remove('sliderProgress--active');
      activeProgressBar?.classList.add('sliderProgress--active');
    });

    bigSlider.on('slideChangeTransitionEnd', () => {
      const otherProgressBars = document.querySelectorAll('.js-sliderProgress');
      otherProgressBars.forEach((element, index) => {
        element.classList.remove('sliderProgress--animate');
      });
      const activeProgressBar = document.querySelector('.swiper-slide-thumb-active .js-sliderProgress');
      activeProgressBar?.classList.add('sliderProgress--animate');
    });
  }
}
